export enum DocumentCategory {
  Identity = 'identity',
  ResidenceProof = 'residence-proof',
  BankInformation = 'bank-information',
  FundingProof = 'funding-proof',
  Retro = 'retro',
  AdviceReport = 'advice-report',
  SituationStatement = 'situation-statement',
  ManagementTransaction = 'management-transaction',
  Billing = 'billing',
  Contract = 'contract',
  ProductInformation = 'product-information',
  Tax = 'tax'
}
